export default "__VITE_ASSET__MyqTIzgQ__"